<template>
  <div>
    <div class="content_center">
      <div class="content_center-center active">
        <template v-if="liveUrl != ''">
          <div class="content_video_box">
            <tc-player-live
             v-for="(i,n) in sortLive[liveIndex]" :key="n"
              ref="tcplayer"
              :id="i.id"
              :liveUrl="i.flvPlayUrl"
              :widthHeigt="[100, 100]"
            ></tc-player-live>
          </div>
        </template>
      </div>
      <template v-if="liveUrl == ''">
        <div class="content_video_box no-play-video">暂无数据</div>
      </template>
    </div>
    <div class="center_right">
      <div class="center_right_live">
        <div class="center_right_live_head">
          <div>直播视频列表</div>
          <div @click="getLiveList">刷新</div>
        </div>
        <div v-for="(i,n) in sortLive" :key="n"
        @click="getLive(item, n)"
        >
          <div
          class="live-list-li"
          :class="{ active: liveIndex == n }"
          v-for="(item, index) in i"
          :key="item.id"
        
        >
          {{ item.liveName }}
        </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import TcPlayerLive from "./TcPlayerLive.vue";
export default {
  name: "DrillCenterLive",
  components: {
    TcPlayerLive
  },
  props: {
    schoolId: {
      type: Number,
      default: {
        return: 0
      }
    },
    drillPlanId: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      liveUrl: "",
      liveList: [],
      liveIndex: 0,
      sortLive:[]
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    getLive(item, index) {
      this.liveIndex = index;
      // this.liveUrl = item.flvPlayUrl;
    },
    reFreshlive(){
     this.liveUrl=""
     this.liveList= []
     this.liveIndex= 0
    },
    // 获取应急演练中心直播列表
    async getLiveList() {
      this.sortLive=[]
      let req = {
        schoolId: this.schoolId,
        drillPlanId: this.drillPlanId
      };
      let res = await this.$Http.getLiveList(req);
      if (res.code == 200) {
        // console.log(res);
        this.liveList = res.data;
        if (this.liveList.length > 0) {
          let str = 0;
          let arr= []
        
          this.liveList.map(item=>{
              str++;
              arr.push(item)
              if(str==this.liveList.length||arr.length==3){
                  this.sortLive.push(arr)
                  arr=[]
              }
           
          })


          this.liveIndex = 0;
          this.liveUrl = this.liveList[0].flvPlayUrl;
        } else {
          this.liveUrl = "";
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.content_center {
  height: 100%;
  width: 70%;
  float: left;
  position: relative;
  .content_center-center {
    opacity: 0;
    width: 100%;
    height: 0;
    position: absolute;
    left: 0;
    top: 0;
    &.active {
      height: 100%;
      opacity: 1;
      /deep/ .content_video_box {
        height: 100%;
      }
    }
  }
  /deep/ .content_video_box {
    width: 100%;
    height: 0;
    float: left;
    position: relative;
    display: flex;
    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
      video {
        width: 100%;
        height: 100%;
        // object-fit: fill;
      }
    }
    video {
      width: 100%;
      height: 100%;
    }
    &.no-play-video {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.center_right {
  width: 25%;
  height: 100%;
  float: left;
  background-image: url('~@/assets/img/drillCenter/right_bottom.png');
  background-size: 100% 100%;
    overflow-y: auto;
  padding: 0 2rem;
}

.center_right_live {
  float: left;
  width: 100%;
  position: relative;
}
.center_right_live_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-top: 10px;
  div {
    font-size: 18px;
    color: #fff9d8;
    &:last-child {
      font-size: 14px;
      cursor: pointer;
      color: rgba(255, 249, 216, 0.8);
      &:hover {
        color: #fff9d8;
      }
    }
  }
}
.live-list-li {
  padding: 10px 10px;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.6);
  background: #2c316c;
  cursor: pointer;
  &.active {
    color: rgb(255, 255, 255);
    background: rgba(157, 164, 255, 0.8);
  }
}
</style>
